import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import MenuBotones from "../../MenuBotones";

function BotonesCompras() {
  const { user } = useContext(AuthContext);

  const SECCIONES = [
    { section: "Compras", items: [
      { label: "Ordenes de Compra", icon: "fas fa-file-signature", color: "#3b82f6", href: "/ListadoOrdenesCompra", desc: "Pedidos de vino a importadores y distribuidores", enabled: !!user.menu_oc },
      { label: "Pendiente Recibir", icon: "fas fa-hourglass-half", color: "#6366f1", href: "/ListadoPendRecibir", desc: "Vino pedido que aun no llega", enabled: !!user.pendiente_recibir },
      { label: "Recepciones", icon: "fas fa-boxes", color: "#10b981", href: "/ListadoCompras", desc: "Entradas de vino sobre la orden de compra", enabled: !!user.menu_compras },
      { label: "Sugerido de compra", icon: "fas fa-lightbulb", color: "#f59e0b", href: "/SugeridoCompra", desc: "Que pedir para la temporada", enabled: !!user.menu_oc },
      { label: "Devoluciones", icon: "fas fa-undo-alt", color: "#ef4444", href: "/ListadoDevolucionesProveedores", desc: "Devoluciones a proveedores", enabled: !!user.menu_compras },
    ]},
    { section: "Catalogos", items: [
      { label: "Proveedores", icon: "fas fa-wine-bottle", color: "#64748b", href: "/Proveedores", desc: "Importadores y distribuidores", enabled: !!user.menu_proveedores },
    ]},
  ];

  return (
    <MenuBotones
      titulo="Compras"
      descripcion="Ordenes de compra y recepcion de vino"
      icono="fas fa-shopping-cart"
      color="#3b82f6"
      secciones={SECCIONES}
    />
  );
}

export default BotonesCompras;
